const CLIENTS = [
  {
    name: "Musette",
    url: "https://musette.ro",
    logo: "https://static.musette.ro/pub/media/logo/stores/1/logotip_musette_welcome_page.png",
  },
  {
    name: "Caretta",
    url: "https://caretta.ro",
    logo: "https://caretta.ro/wp-content/uploads/2025/08/logo-caretta.webp",
  },
  {
    name: "Delv",
    url: "https://delv.ro",
    logo: "https://delv.ro/wp-content/uploads/2023/01/logo-header-delv.png",
  },
  {
    name: "Clinica Hope",
    url: "https://clinica-hope.ro",
    logo: "https://clinica-hope.ro/wp-content/uploads/2018/10/l1.gif",
  },
  {
    name: "Panifcom",
    url: "https://panifcom.ro",
    logo: "https://panifcom.ro/wp-content/uploads/2024/09/logo-panifcom-red.png",
  },
];

const ClientLogos = () => {
  // Duplicate for seamless marquee loop
  const loop = [...CLIENTS, ...CLIENTS];

  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative py-20 lg:py-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">
            <span className="h-px w-8 bg-electric" />
            Clienții noștri
          </div>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900">
            Branduri care{" "}
            <span className="text-magenta">cresc</span> cu noi.
          </h2>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl">
            De la fashion și sănătate la industrie și panificație — lucrăm cu echipe
            de marketing serioase, care vor rezultate, nu rapoarte stufoase.
          </p>
        </div>
      </div>

      <div className="relative mt-14 lg:mt-20">
        {/* Fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 sm:w-40 z-10 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 sm:w-40 z-10 bg-gradient-to-l from-white to-transparent" />

        <div
          data-testid="clients-marquee"
          className="flex gap-12 sm:gap-20 animate-marquee whitespace-nowrap items-center"
          style={{ animationDuration: "35s" }}
        >
          {loop.map((c, i) => (
            <a
              key={`${c.name}-${i}`}
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`client-logo-${c.name.toLowerCase().replace(/\s+/g, "-")}-${i}`}
              className="group flex-shrink-0 h-20 sm:h-24 w-44 sm:w-56 grid place-items-center rounded-2xl border border-slate-200 bg-white hover:border-slate-300 transition-all hover:-translate-y-0.5"
              title={c.name}
              aria-label={c.name}
            >
              <img
                src={c.logo}
                alt={c.name}
                loading="lazy"
                className="max-h-12 sm:max-h-14 max-w-[75%] w-auto object-contain filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
